(function() {
  'use strict';

  angular
    .module('axreg.forgotPassword.controller', []);

  angular
    .module('axreg.forgotPassword.service', []);

  angular
    .module('axreg.forgotPassword', ['axreg.forgotPassword.controller', 'axreg.forgotPassword.service'])
    .config(forgotPasswordConfig);

  /** @ngInject */
  function forgotPasswordConfig($stateProvider) {
    $stateProvider
      .state('forgot-password', {
        url: "/forgot-password",
        templateUrl: "app/features/forgot_password/forgot_password.html",
        controller: 'ForgotPasswordController',
        controllerAs: 'vm'
      })
      .state('password-reset', {
        url: "/password-reset/:hash",
        templateUrl: "app/features/forgot_password/reset/forgot_password_reset.html",
        controller: 'ForgotPasswordResetController',
        controllerAs: 'vm'
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('axreg.forgotPassword.controller')
    .controller('ForgotPasswordResetController', ForgotPasswordResetController);

  /** @ngInject */
  function ForgotPasswordResetController($state, notify, ForgotService) {
    var vm = this;

    function changePassword() {
      if (vm.form.$valid) {
        ForgotService.changePassword({password_new: vm.forgot.password_new, hash_validation: $state.params.hash}).then(function() {
          notify({
            message: 'Nova senha cadastrada com sucesso.',
            classes: 'alert-success'
          });
          $state.go('login');
        });
      }
    }

    vm.changePassword = changePassword;
  }

})();

(function() {
  'use strict';

  angular
    .module('axreg.profile.controller', []);

  angular
    .module('axreg.profile.service', []);

  angular
    .module('axreg.profile',['axreg.profile.controller','axreg.profile.service'])
    .config(profileConfig);

  /** @ngInject */
  function profileConfig($stateProvider) {
    $stateProvider

      .state('profile', {
        abstract: true,
        url: "/profile",
        templateUrl: "app/common/template/content_top_navigation.html",
        controller: 'NavigationController',
        controllerAs: 'navigation'
      })
      .state('profile.main', {
        url: "/main",
        templateUrl: "app/features/profile/profile.html",
        controller: 'ProfileController',
        controllerAs: 'vm',
        resolve: {
          profile: function(ProfileService){
            return ProfileService.getProfile();
          },
          countries: function(ProfileService){
            return ProfileService.countries();
          },
          states: function(ProfileService){
            return ProfileService.states();
          }
        }
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('axreg.profile.controller')
    .controller('ProfileController', ProfileController);

  /** @ngInject */
  function ProfileController(profile, countries, states, ProfileService, notify, $state) {
    var vm = this;

    vm.profile = profile;
    vm.countries = countries;
    vm.states = states;
    vm.atualizar = atualizar;

    function setInitFields() {
      vm.country = _.findWhere(vm.countries, { id: profile.country_id });
      vm.crmState = _.findWhere(vm.states, { id: profile.state_id });
      vm.state = _.findWhere(vm.states, { id: profile.state_id });
      vm.crmState = _.findWhere(vm.states, { id: profile.crm_state_id });
    }

    function atualizar() {
      var obj = angular.copy(vm.profile);
      obj.crm_state_id = vm.crmState.id;
      obj.country_id = vm.country.id;
      obj.state_id = vm.state ? vm.state.id : null;
      if (vm.form.$valid) {
        ProfileService.update(obj).then(function() {
          notify({
            message: "Dados atualizado",
            classes: 'alert-sucess'
          });
          $state.go('procedure.list')
        });
      }
    }

    setInitFields();
  }

})();

(function() {
  'use strict';

  angular
    .module('axreg.procedure.controller', []);

  angular
    .module('axreg.procedure.service', []);

  angular
    .module('axreg.procedure',['axreg.procedure.controller','axreg.procedure.service'])
    .config(procedureConfig);

  /** @ngInject */
  function procedureConfig($stateProvider) {
    $stateProvider

      .state('procedure', {
        abstract: true,
        url: "/procedure",
        templateUrl: "app/common/template/content_top_navigation.html",
        controller: 'NavigationController',
        controllerAs: 'navigation'
      })
      .state('procedure.list', {
        url: "/main",
        templateUrl: "app/features/procedure/procedure.list.html",
        controller: 'ProcedureController',
        controllerAs: 'vm',
        resolve: {
          procedures: function(ProcedureService){
            // componente esta com comportamento inesperado, e so ta rolando com esse formato, fazer um refact mais tarde
            var startDate = moment().format('MM/01/YYYY');
            var endDate = moment(startDate, 'MM/DD/YYYY').endOf('month').format('MM/DD/YYYY');
            return ProcedureService.getAll({startDate: startDate, endDate: endDate});
          },
          reports: function(ProcedureService){
            // componente esta com comportamento inesperado, e so ta rolando com esse formato, fazer um refact mais tarde
            var startDate = moment().format('MM/01/YYYY');
            var endDate = moment(startDate, 'MM/DD/YYYY').endOf('month').format('MM/DD/YYYY');
            return ProcedureService.reports({startDate: startDate, endDate: endDate});
          }
        }
      })
  }
})();

'use strict';

angular.module('axreg.procedure.controller')
  .controller('ProcedureController', function($compile, $window, $location, $scope, $config, $timeout, notify, reports, procedures, TranslateDataTable, ProcedureService, DTOptionsBuilder, DTColumnDefBuilder, configDatePicker_PTBr, DTColumnBuilder, FileSaver, Blob) {    var vm = this;

    vm.procedures = procedures;

    vm.reports = reports;
    var startDate = moment().format('MM/DD/YYYY');
    var endDate = moment(startDate, 'MM/DD/YYYY').endOf('month').format('MM/DD/YYYY');


    vm.filtro = {
      tipo: 'list',
      date: {
        startDate: startDate,
        endDate: endDate
      }
    }

    vm.noPdfAvailable = function (id) {
      notify({
        message: "Ficha de anestesia não sincronizada pelo Aplicativo. Certifique-se de ter concluído o procedimento, gerado o PDF e sincronizado os dados.",
        classes: 'alert-info'
      });
    };

    vm.openPdf = function (id) {
      ProcedureService.pdfUrl(id).then(function (data) {
        $window.open(data, '_blank');
      });
    };

    vm.filtrar = function () {
      if (moment.isMoment(vm.filtro.date.endDate)) {
        vm.filtro.date.endDate = vm.filtro.date.endDate.format('MM/DD/YYYY')
      }
      if (moment.isMoment(vm.filtro.date.startDate)) {
        vm.filtro.date.startDate = vm.filtro.date.startDate.format('MM/DD/YYYY')
      }
      if (vm.form.$valid) {
        ProcedureService.getAll(vm.filtro.date).then(function (procedures) {
          vm.procedures = procedures;
          ProcedureService.reports(vm.filtro.date).then(function (reports) {
            vm.reports = reports;
            setDataGraphics();
          })
        });
      }
    };

    vm.opts = angular.copy(configDatePicker_PTBr);

    vm.opts.eventHandlers = {
      'apply.daterangepicker': vm.filtrar
    }

    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withPaginationType('full_numbers')
      .withDisplayLength(10)
      .withOption('createdRow', function (row) {
        var r = angular.element(row).contents()        
        var date = r[0].textContent
        var dateFormated = moment(date).format("DD/MM/YYYY HH:mm")
        console.log('DATE', dateFormated)
        r[0].textContent = dateFormated
        $compile(r)($scope)
      })
      .withOption('deferRender', true)
      .withLanguage(TranslateDataTable);

    vm.dtColumns = [
      DTColumnBuilder.newColumn('date').withTitle('Data').withOption('type', 'datetime-local'),
      DTColumnBuilder.newColumn('patient').withTitle('Paciente'),
      DTColumnBuilder.newColumn('procedure').withTitle('Procedimento'),
      DTColumnBuilder.newColumn('medical_plan').withTitle('Convênio'),
      DTColumnBuilder.newColumn('procedure_value').withTitle('Valor'),
      DTColumnBuilder.newColumn('adverse_effect').withTitle('Intercorrência'),
      DTColumnBuilder.newColumn('download_pdf').withTitle('PDF')
    ];
    vm.dt
    vm.changeValue = function (id, event) {
      var obj = {
        id: id,
        procedure_value: event.currentTarget.value
      }
      ProcedureService.update(obj).then(function () {
        notify({
          message: "Valor atualizado",
          classes: 'alert-sucess'
        });
      })
    }

    function setDataGraphics() {
      setDataPie(vm.reports);
      setDataBar(vm.reports.procedures);
    }

    function setDataPie(data) {
      var hoursPie = _.each(data.hours, function (val) {
        val['y'] = parseInt(val.quantity.toFixed(2))
      });

      vm.chartConfig.series[0].data = hoursPie;

      var medicalPlansPie = _.each(data.medical_plans, function (value) {
        value['y'] = parseInt(value.quantity.toFixed(2))
      });
      vm.chartConfig3.series[0].data = medicalPlansPie;
    }

    function setDataBar(data) {
      vm.chartConfig2.series[0].data = _.pluck(data, 'quantity');
      vm.chartConfig2.options.xAxis.categories = _.pluck(data, 'name');
    }

    vm.chartConfig = {
      options: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true
            },
            showInLegend: true,
            innerSize: 140
          }
        }
      },
      series: [{
        name: 'Horas Trabalhadas',
        colorByPoint: true,
        data: []
      }]
    }

    vm.chartConfig2 = {
      options: {
        chart: {
          type: 'bar'
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage}%</b>'
        },
        xAxis: {
          categories: _.pluck(reports.procedures, 'name'),
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          title: {
            text: '',
            align: 'high'
          },
          labels: {
            overflow: 'justify'
          }
        },
        plotOptions: {
          bar: {
            dataLabels: {
              enabled: true
            }
          }
        }
      },
      series: [{
        name: 'Procedimentos',
        data: _.pluck(reports.procedures, 'quantity')
      }]
    }

    vm.chartConfig3 = {
      options: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true
            },
            showInLegend: true
          }
        }
      },
      series: [{
        name: 'Representa ',
        colorByPoint: true,
        data: reports.medical_plans
      }]
    }

    setDataGraphics();

    vm.formatNames = function (v) {
      return v.map(function (values) {
        return values.name
      }).join(', ')
    }
  });

(function() {
  'use strict';

  angular
    .module('axreg.login.controller', []);

  angular
    .module('axreg.login.token.controller', []);

  angular
    .module('axreg.login.service', []);

  angular
    .module('axreg.login', ['axreg.login.controller', 'axreg.login.token.controller', 'axreg.login.service'])
    .config(loginConfig);

  /** @ngInject */
  function loginConfig($stateProvider) {
    $stateProvider
      .state('login', {
        url: "/login",
        templateUrl: "app/features/login/login.html",
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('login-token', {
        url: "/login/:token",
        templateUrl: "app/features/login/login-token.html",
        controller: 'LoginTokenController',
        controllerAs: 'vm'
      })
  }
})();


(function() {
  'use strict';
  angular
    .module('axreg.login.token.controller')
    .controller('LoginTokenController', LoginTokenController);

  /** @ngInject */
  function LoginTokenController($state, $cookies, $rootScope, LoginService) {
    var token = atob($state.params.token);

    $cookies.put('axreg_token',   token);
    LoginService.refresh().then(function(user){
      $rootScope.user = user;
      $cookies.putObject('axreg_user', user);
      $state.go('procedure.list');
    });

  }

})();

(function() {
  'use strict';
  angular
    .module('axreg.login.controller')
    .controller('LoginController', LoginController);

  /** @ngInject */
  function LoginController($state, $cookies, $rootScope, LoginService) {
    var vm = this;

    function logar() {
      if (vm.form.$valid) {
        LoginService.login(vm.credentials).then(function(user){
          $rootScope.user = user;
          window.localStorage.setItem('user_data', JSON.stringify(user));
          $cookies.putObject('axreg_user', user);
          $state.go('procedure.list');
        });
      }
    }

    vm.logar = logar;
  }

})();

(function() {
  'use strict';

  angular
    .module('axreg.home.controller', []);

  angular
    .module('axreg.home.service', []);

  angular
    .module('axreg.home', ['axreg.home.controller', 'axreg.home.service'])
    .config(homeConfig);

  /** @ngInject */
  function homeConfig($stateProvider) {
    $stateProvider
      .state('home', {
        url: "/",
        templateUrl: "app/common/template/content_top_navigation.html",
        controller: 'NavigationController',
        controllerAs: 'home'
      })
  }
})();

(function() {
  'use strict';
  angular
    .module('axreg.forgotPassword.controller')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController($state, notify, ForgotService) {
    var vm = this;

    function enviarEmail() {
      if (vm.form.$valid) {
        ForgotService.resetPass(vm.forgot).then(function() {
          notify({
            message: 'A instruções para resetar sua senha foi enviado por email.',
            classes: 'alert-success'
          });
          $state.go('login');
        });
      }
    }

    vm.enviarEmail = enviarEmail;
  }

})();

'use strict';

angular
  .module('axreg.security.factories', []);

angular
  .module('axreg.security', [
    'axreg.security.factories'
  ])
  .config(function($httpProvider) {

    $httpProvider.interceptors.push('SecurityInterceptor');
  });

'use strict';
angular.module('axreg.security.factories')
  .factory('SecurityInterceptorMessages', function($rootScope, $injector, $translate) {

    function notify() {
      return $injector.get('notify');
    }

    return {
      apply401: function() {
        $rootScope.configData = {
          'autenticado': false,
          'login': null
        };
        var state = $injector.get('$state');
        state.go('login');
        notify()({
          message: $translate.instant('exception.usuario.nao.autenticado'),
          classes: 'alert-danger'
        });
      },

      apply400: function(rejection) {
        switch (rejection.data) {
          case 'hash.expired':
            notify()({
              message: 'Não foi possivel atualizar sua senha, link expirado',
              classes: 'alert-danger'
            });
            break;
          default:
            notify()({
              message: $translate.instant('exception.bad.request'),
              classes: 'alert-danger'
            });
            break;
        }
      },
      apply403: function(rejection) {
        switch (rejection.data) {
          case 'aplicacao.nao.encontrada':
            notify()({
              message: $translate.instant('exception.aplicacao.nao.encontrada'),
              classes: 'alert-danger'
            });
            break;
          case 'usuario.ou.senha.invalidos':
          case 'Bad credentials':
            notify()({
              message: $translate.instant('exception.bad.credentials'),
              classes: 'alert-danger'
            });
            break;
          case 'usuario.desativado':
            notify()({
              message: $translate.instant('exception.usuario.desativado'),
              classes: 'alert-danger'
            });
            break;
          default:
            notify()({
              message: $translate.instant('rejection.data'),
              classes: 'alert-danger'
            });
            break;
        }
      },
      apply404: function(rejection) {
        switch (rejection.data) {
          case 'user.not.found':
            notify()({
              message: 'Email não encontrado em nossa base de dados',
              classes: 'alert-danger'
            });
            break;
          case 'hash.not.found':
            notify()({
              message: 'Não foi possivel atualizar sua senha, link expirado',
              classes: 'alert-danger'
            });
            break;
          default:
            notify()({
              message: $translate.instant('exception.service.unavailable'),
              classes: 'alert-danger'
            });
            break;
        }
      },
      apply412: function(rejection) {
        notify()({
          message: $translate.instant('exception.'+rejection.data),
          classes: 'alert-danger'
        });
      },
      apply500: function() {
        notify()({
          message: $translate.instant('exception.erro.generico'),
          classes: 'alert-danger'
        });
      },
      apply502: function() {
        notify()({
          message: $translate.instant('exception.service.unavailable'),
          classes: 'alert-danger'
        });
      },
      apply503: function() {
        this.apply503();
      }
    };
  });

'use strict';
angular.module('axreg.security.factories')
  .factory('SecurityInterceptor', function($q, $window, $cookies, SecurityInterceptorMessages) {
    return {
      request: function(config) {
        config.headers = config.headers || {};
        var cookieToken = $cookies.get('axreg_token');
        if (cookieToken) {
          config.headers['Authorization'] = cookieToken;
        }
        return config;
      },
      response: function(response) {
        if (response.config.headers['Content-Type'] === "application/json;charset=utf-8") {
          var auth = response.headers().authorization;
          if (auth) {
              $cookies.put('axreg_token',  auth );
          }
        }
        return response;
      },
      responseError: function(rejection) {

        switch (rejection.status) {
          case 0:
            SecurityInterceptorMessages.apply420(rejection);
            break;
          case 400:
            SecurityInterceptorMessages.apply400(rejection);
            break;
          case 401:
            SecurityInterceptorMessages.apply401(rejection);
            $q.reject(rejection);
            break;
          case 403:
            SecurityInterceptorMessages.apply403(rejection);
            break;
          case 404:
            SecurityInterceptorMessages.apply404(rejection);
            break;
          case 412:
            SecurityInterceptorMessages.apply412(rejection);
            break;
          case 420:
            SecurityInterceptorMessages.apply420(rejection);
            break;
          case 500:
            SecurityInterceptorMessages.apply500(rejection);
            break;
          case 502:
          case 503:
            SecurityInterceptorMessages.apply502(rejection);
            break;
          default:
            $q.reject(rejection);
            break;
        }
        return $q.reject(rejection);
      }
    };
  });

(function() {
  'use strict';

  angular
    .module('axreg.directives', []);

  angular
    .module('axreg', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ngResource',
      'ngFileSaver',
      'ui.router',
      'ui.select',
      'ui.bootstrap',
      'daterangepicker',
      'cgNotify',
      'highcharts-ng',
      'pascalprecht.translate',
      'datatables',
      'ui.select',
      'axreg.filter',
      'axreg.login',
      'axreg.profile',
      'axreg.procedure',
      'axreg.directives',
      'axreg.forgotPassword',
      'axreg.security'
    ]);
})();

'use strict';
angular.module('axreg.directives')
    .factory('BreadCrumbService', function() {
        return {
            params: []
        };
    });
'use strict';

angular.module('axreg')
  .directive('compBreadcrumbs', function($rootScope, $location, $translate, BreadCrumbService) {
    return {
      restrict: 'E',
      templateUrl: 'app/directives/breadcrumbs/breadcrumbs.html',
      link: function() {
        var paths, urls;
        if ($location.path() === '/') {
          $rootScope.breadcrumbs = [];
        } else {
          paths = $location.path().split('/').slice(1);
          urls = $location.path().split('/').slice(1);

          //gato 
          if (paths[(paths.length - 1)] == 'main') {
            paths.pop();
          }
        }

        $rootScope.breadcrumbs = _.map(paths, function(path, index) {
          var nome = $translate.instant('breadcrumb.' + path).replace('breadcrumb.', '');
          return {
            path: nome,
            // oldState: fromState.name,
            url: '' + (urls.slice(0, +index + 1 || 9e9).join('/'))
          };
        });
        $rootScope.$on('$stateChangeSuccess', stateChangeSuccess); // eslint-disable-line

        function stateChangeSuccess(event, toState) {
          if (toState.data && toState.data.pageTitle) {
            $rootScope.label = toState.data.pageTitle;
          }
          if (angular.isDefined(toState.breadcrumbs)) {
            $rootScope.breadcrumbs = angular.copy(toState.breadcrumbs);

            _.each($rootScope.breadcrumbs, function(breadcrumb) {
              _.each(BreadCrumbService.params, function(param) {
                if (breadcrumb[param.field] === param.chave) {
                  if (angular.isDefined(param.hide)) {
                    breadcrumb.hide = param.hide;
                  }
                  breadcrumb[param.field] = param.value;
                }
              });
            });
          }
        }
      }
    };
  });

(function() {
  'use strict';

  angular
    .module('axreg.profile.service')
    .factory('ProfileService', ProfileService);

  function ProfileService($config, $http) {

    var service = {
      getProfile: getProfile,
      states: states,
      countries: countries,
      update    : update

    };
    return service;

    function getProfile() {
      return $http.get($config.APP_BASE_URL + '/anaesthetists/me').then(function(response) {
        return response.data;
      });
    }

    function transformResponseCountries(data) {
      var ret = [];
      if (data) {
        var countries = angular.copy(angular.fromJson(data));
        _.each(countries, function(country) {
          var item = _.findWhere(country.country_i18n, { language_id: 'pt-BR' });
          ret.push(item);
        });
      }
      return ret;
    }

    function update(data) {
      return $http({
        url: $config.APP_BASE_URL + '/anaesthetists/' + data.id,
        method: 'PUT',
        data: data
      }).then(function(response) {
        return response.data;
      });
    }

    function countries() {
      return $http({
        url: $config.APP_BASE_URL + '/countries',
        method: 'GET',
        transformResponse: transformResponseCountries
      }).then(function(response) {
        return response.data;
      });
    }

    function states() {
      return $http.get($config.APP_BASE_URL + '/states').then(function(response) {
        return response.data;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('axreg.procedure.service')
    .factory('ProcedureService', ProcedureService);

  function ProcedureService($config, $http) {

    var service = {
      getAll    : getAll  ,
      update    : update  ,
      reports   : reports,
      pdf       : pdf,
      pdfUrl    : pdfUrl
    };
    return service;

    function getAll(date) {
      if (date && date.startDate && date.endDate) {
        var params    = {
          start_date  : moment(date.startDate,'MM/DD/YYYY').format('DD/MM/YYYY'),
          end_date    : moment(date.endDate,'MM/DD/YYYY').format('DD/MM/YYYY')
        }
      }
      return $http({
        url     : $config.APP_BASE_URL + '/procedures',
        method  : 'GET',
        params  : params
      }).then(function(response) {
        return response.data;
      });
    }

    function update(procedure) {
      procedure.procedure_value = procedure.procedure_value.replace(/\./g, "").replace(',','.')
      return $http({
        url     : $config.APP_BASE_URL + '/procedures/' + procedure.id,
        method  : 'PUT',
        data    : procedure
      }).then(function(response) {
        return response.data;
      });
    }

    function pdf(id){
      return $http({
        url     : $config.APP_BASE_URL + '/procedures/'+id+'/pdf',
        method  : 'GET',
        responseType:'arraybuffer'
      }).then(function(response) {
        return response.data;
      });
    }
    function pdfUrl(id){
      return $http({
        url     : $config.APP_BASE_URL + '/procedures/'+id+'/pdf_url',
        method  : 'GET'
      }).then(function(response) {
        return response.data;
      });
    }

    function transformResponseReports(report) {
      var obj   = angular.copy(angular.fromJson(report));

      _.each(obj.hours, function(hour) {
        hour.y  = hour.time;
      });

      _.each(obj.procedures, function(procedure) {
        procedure.y = procedure.quantity;
      });

      _.each(obj.medical_plans, function(plans) {
        plans.y = plans.quantity;
      });

      return obj;
    }

    function reports(date) {
      if (date && date.startDate && date.endDate) {
        var params    = {
          start_date  : moment(date.startDate,'MM/DD/YYYY').format('DD/MM/YYYY'),
          end_date    : moment(date.endDate,'MM/DD/YYYY').format('DD/MM/YYYY')
        }
      }
      return $http({
        url     : $config.APP_BASE_URL + '/reports',
        method  : 'GET',
        params  : params,
        transformResponse: transformResponseReports
      }).then(function(response) {
        return response.data;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('axreg.login.service')
    .factory('LoginService', LoginService);

  function LoginService($config, $http) {

    var service = {
      login     : login,
      refresh   : refresh
    };
    return service;

    function login(data) {
      return $http.post($config.APP_BASE_URL + '/login', data).then(function(response) {
        return response.data;
      });
    }

    function refresh() {
      return $http.get($config.APP_BASE_URL + '/login/refresh').then(function(response) {
        return response.data;
      });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('axreg.forgotPassword.service')
    .factory('ForgotService', ForgotService);

  function ForgotService($config, $http) {

    var service = {
      resetPass       : resetPass,
      changePassword  :changePassword
    };
    return service;

    function resetPass(data) {
      return $http.post($config.APP_BASE_URL + '/users/passwordReset',data);
    }

    function changePassword(data){
      return $http.put($config.APP_BASE_URL + '/users/passwordUpdate',data);
    }
  }
})();
'use strict';

angular.module('axreg.filter', [])
  .filter('propsFilter', function() {
    return function(items, props) {
      var out = [];

      if (angular.isArray(items)) {
        items.forEach(function(item) {
          var itemMatches = false;

          var keys = Object.keys(props);
          for (var i = 0; i < keys.length; i++) {
              var prop = keys[i];
              var text = props[prop].toLowerCase();
              if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                  itemMatches = true;
                  break;
              }
          }

          if (itemMatches) {
              out.push(item);
          }
        });
      } else {
        // Let the output be the input untouched
        out = items;
      }

        return out;
    };
  });

'use strict';

angular.module('axreg')
  .provider('Translate', function() {
    return {
      pt_BR: function() {
        return {
          breadcrumb: {
            procedure: 'Procedimentos'
          },
          form: {
            REQUIRED: 'Campo obrigatório',
            INVALID_EMAIL: 'Email inválido',
            FILTRAR: 'Filtrar',
            CPF_INVALID: 'CPF inválido',
            PATTERN: 'O password deve conter no minímo 1 maiúscula, números e letras'
          },
          login: {
            LOGIN: 'Login',
            ENTRY: 'Entrar',
            EMAIL: 'Email',
            PASSWORD: 'Senha',
            CONFIRM_PASSWORD: 'Confirmação senha',
            FORGOT_PASSWORD: 'Recuperar senha'
          },
          forgot: {
            INFO_EMAIL: 'Informe o email cadastrado no sistema para redefinir a sua senha',
            FORGOT_PASSWORD: 'Recuperar senha',
            SEND_NEW_PASS: 'Enviar nova senha',
            RESET_PASSWORD: 'Resetar senha',
            INFO_PASS: 'Informe sua nova senha nos campos abaixo',
            CHANGE_PASS: 'Atualizar senha',
            PASSWORD_DISTINCT: 'Senha e confirmação senha devem ser iguais'
          },
          profile: {
            NAME: 'Nome',
            CPF: 'CPF',
            COUNTRY: 'Pais',
            CRM: 'CRM',
            EMAIL: 'Email',
            INFO_ADD: 'INFORMAÇÕES COMPLEMENTARES',
            RQE: 'RQE',
            STATE: 'Estado',
            PHONE:'Telefone',
            REFRESH_DATA: 'Atualizar meus dados'
          },
          exception: {
            'can.not.update.procedure': 'Não foi possivel atualizar o procedimento',
            'aplicacao.nao.encontrada': 'Aplicação não encontrada',
            'usuario.ou.senha.invalidos': 'Usuário inválido',
            'bad.credentials': 'Bad credencials',
            'usuario.desativado': 'Usuário Desativado',
            'usuario.expirado': 'Sessão Expirada',
            'erro.generico': 'Ocorreu um erro não identificado, por favor contate Admin.',
            'service.unavailable': 'Serviço indisponível',
            'usuario.nao.autenticado': 'Usuário não autorizado',
            'bad.request': 'Bad Request'
          }
        };
      },
      $get: function() {
        return this.pt_BR();
      }
    };

  });

'use strict';

angular.module('axreg')
  .provider('TranslateDataTable', function() {
    return {
      pt_BR: function() {
        return {
          "sEmptyTable": "Nenhum registro encontrado",
          "sInfo": "Mostrando de _START_ até _END_ de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando 0 até 0 de 0 registros",
          "sInfoFiltered": "(Filtrados de _MAX_ registros)",
          "sInfoPostFix": "",
          "sInfoThousands": ".",
          "sLengthMenu": "Registro por página:  _MENU_",
          "sLoadingRecords": "Carregando...",
          "sProcessing": "Processando...",
          "sZeroRecords": "Nenhum registro encontrado",
          "sSearch": "Filtrar por: ",
          "oPaginate": {
            "sNext": "Próximo",
            "sPrevious": "Anterior",
            "sFirst": "Primeiro",
            "sLast": "Último"
          },
          "oAria": {
            "sSortAscending": ": Ordenar colunas de forma ascendente",
            "sSortDescending": ": Ordenar colunas de forma descendente"
          }
        };
      },
      $get: function() {
        return this.pt_BR();
      }
    };

  });

'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('axreg.directives')
    .directive('sideNavigation', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

            }
        };
    });

'use strict';

//Directive minimalize button
angular.module('axreg.directives')
    .directive('minimalizaSidebar', function($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-primary " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function($scope) {
                $scope.minimalize = function() {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function() {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    });

'use strict';

//Directive minimalize button
angular.module('axreg.directives')
  .directive('blurOnClick', function () {
    return {
      link: function (scope, element, attrs) {

        function functionToBeCalled (e) {
          this.blur();
          console.log("It worked!");
        }

        element.on('click', functionToBeCalled);
      }
    };
  });

'use strict';

angular.module('axreg')
  .controller('NavigationController', function($state, $cookies) {

    var vm = this;

    vm.user = $cookies.getObject('axreg_user');

    vm.containInState = function(values) {
      return $state.includes(values);
    }

    vm.logout = function() {
      $cookies.remove('axreg_user');
      $state.go('login');
    }
  });

/**
 * INSPINIA - Responsive Admin Theme
 * 2.6.2
 *
 * Custom scripts
 */

angular.element(document).ready(function($timeout) {

  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = angular.element('nav.navbar-default').height();
    var wrapperHeigh = angular.element('#page-wrapper').height();

    if (navbarHeigh > wrapperHeigh) {
      angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if (navbarHeigh < wrapperHeigh) {
      angular.element('#page-wrapper').css("min-height", angular.element(window).height() + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeigh > wrapperHeigh) {
        angular.element('#page-wrapper').css("min-height", navbarHeigh + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if (!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function() {
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav')) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function() {
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

  var maskBehavior = function (val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
    options = {onKeyPress: function(val, e, field, options) {
        field.mask(maskBehavior.apply({}, arguments), options);
      }
    };

  $('.phone').mask(maskBehavior, options);// eslint-disable-line
  $('.money').mask('000.000.000.000.000,00', {reverse: true});// eslint-disable-line
  $('.cpf').mask('000.000.000-00');// eslint-disable-line

});

(function() {
  'use strict';

  angular
    .module('axreg')
    .config(config);

  function config($urlRouterProvider, $locationProvider, $httpProvider, $translateProvider, TranslateProvider) {
    $httpProvider.defaults.withCredentials = true;
    $urlRouterProvider.otherwise('/login');

    $translateProvider.translations('pt_Br', TranslateProvider.pt_BR());
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    $translateProvider.preferredLanguage('pt_Br');

    $locationProvider.html5Mode(true);
  }

  angular
    .module('axreg')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {
    $log.debug('runBlock end');
  }
})();

(function() {
  'use strict';

  angular
    .module('axreg')
    .constant('$config', window.config) // eslint-disable-line
    .constant('moment', moment)
    .constant('configDatePicker_PTBr', {
      locale: {
        format: "DD/MM/YYYY",
        language: 'pt-BR',
        separator: " à ",
        applyLabel: "Aplicar",
        cancelLabel: "Cancelar",
        fromLabel: "Data inicial",
        toLabel: "Data final",
        weekLabel: "W",
        opens: 'right',
        daysOfWeek: [
          "Seg",
          "Ter",
          "Qua",
          "Qui",
          "Sex",
          "Sáb",
          "Dom"
        ],
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        "firstDay": 1
      },
      "autoApply": true,
      opens: 'left'
    });

})();

angular.module("axreg").run(["$templateCache", function($templateCache) {$templateCache.put("app/common/template/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/common/template/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/common/template/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/common/template/footer.html\'\"></div></div></div>");
$templateCache.put("app/common/template/content_top_navigation.html","<div id=\"wrapper\" class=\"top-navigation\"><div ng-include=\"\'app/common/template/top_navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div class=\"row wrapper border-bottom white-bg page-heading\"><div class=\"col-lg-12\" style=\"margin-top: 20px;\"><comp-breadcrumbs></comp-breadcrumbs></div></div><div ui-view=\"\"></div><div ng-include=\"\'app/common/template/footer.html\'\"></div></div></div>");
$templateCache.put("app/common/template/footer.html","<style>\n  .modal {\n    display: none;\n    /* Hidden by default */\n    position: fixed;\n    /* Stay in place */\n    z-index: 1;\n    /* Sit on top */\n    left: 0;\n    top: 0;\n    width: 100%;\n    /* Full width */\n    height: 100%;\n    /* Full height */\n    background-color: rgb(0, 0, 0);\n    /* Fallback color */\n    background-color: rgba(0, 0, 0, 0.4);\n    /* Black w/ opacity */\n  }\n\n  /* Modal Content/Box */\n  .modal-content {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    background-color: #fefefe;\n    margin: 15% auto;\n    margin-top: 1%;\n    /* 15% from the top and centered */\n    padding: 20px;\n    border: 1px solid #888;\n    width: 60%;\n    /* Could be more or less, depending on screen size */\n    min-width: 280px;\n    max-width: 500px;\n  }\n\n  .modal-title {\n    margin-bottom: 16px;\n  }\n\n  .modal-divider {\n    border-top: 1px solid #C4C4C4;\n    width: 90%;\n    margin-bottom: 34px;\n  }\n\n  .terms-text {\n    margin: 24px;\n  }\n\n  .terms-text a {\n    color: #1bbfbb;\n  }\n\n  .terms-text a:hover {\n    color: #1e8f8d;\n  }\n\n  .lgpd-img {\n    width: 80%;\n    height: 205;\n  }\n\n  #accept-button {\n    margin-bottom: 16px;\n  }\n\n  .back-to-login {\n    color: #1bbfbb;\n    margin-bottom: 24px;\n  }\n\n  .back-to-login:hover {\n    color: #1e8f8d;\n  }\n</style><div class=\"footer\"><div>Copyright Anestech © 2018</div><div id=\"myModal\" class=\"modal\" data-backdrop=\"static\" data-keyboard=\"false\"><div class=\"modal-content\"><h4 class=\"modal-title\">TERMOS DE USO E POLÍTICA DE PRIVACIDADE</h4><div class=\"modal-divider\"></div><img src=\"assets/images/lgpd.png\" alt=\"lGPD\" class=\"lgpd-img\"><p class=\"terms-text\" strong=\"\">Para prosseguir com seu acesso é necessário aceitar os novos <a href=\"https://anestech.com.br/politica-de-privacidade/\" target=\"framename\">Termos de Uso e Política de Privacidade.</a></p><button id=\"accept-button\" class=\"btn btn-primary\">Aceitar e continuar</button> <a id=\"back-to-login\" class=\"back-to-login\">Voltar à tela de login</a></div></div></div><script>\n  const { id, token } = JSON.parse(localStorage.getItem(\'user_data\'));\n  const platform = \'anestesia.cloud\';\n  const base_URL = \'https://axreg-server.anestech.com.br\' //\'http://localhost:80\'\n\n  // Get the modal, accept button and back to login button\n  var modal = document.getElementById(\"myModal\");\n  var backToLogin = document.getElementById(\"back-to-login\");\n  var acceptButton = document.getElementById(\"accept-button\");\n\n  //open the modal, call when response == pending\n  openModal = function () {\n    modal.style.display = \"block\";\n  }\n  //close the modal, call if request is ok\n  acceptButton.onclick = function () {\n    //make the accept request here\n    userTermsAccept(id, token);\n    modal.style.display = \"none\";\n  }\n  //redirect to login route\n  backToLogin.onclick = function () {\n    window.location.href = \"/login\";\n  }\n\n\n\n  function userTermsStatus(id, token) {\n    let request = new XMLHttpRequest();\n    request.responseType = \"json\";\n\n    request.onreadystatechange = function () {\n      if (request.readyState == 4 && request.status == 200) {\n        const { response } = request;\n        console.log(response.status);\n        if (response.status === \'PENDING\') openModal();\n      }\n    }\n\n    request.open(\"GET\", `${base_URL}/app/users/${id}/terms/status?platform=${platform}`, true);\n    request.withCredentials = true;\n    request.setRequestHeader(\'Authorization\', token);\n    request.send();\n    return\n  }\n\n  async function userTermsAccept(id, token) {\n\n    const putMethod = {\n      method: \'PUT\', // Method itself\n      headers: {\n        \'Content-type\': \'application/json; charset=UTF-8\',\n        \'Authorization\': token\n\n      },\n      body: JSON.stringify({\n        platform: \"anestesia.cloud\"\n      })\n    }\n\n    fetch(base_URL + `/app/users/${id}/terms/accept`, putMethod)\n      .then(function (response) {\n        return response.json()\n      })\n      .then(function (response) {\n        console.log(response.status);\n      }).catch(function (error) {\n        console.log(error);\n      })\n\n  }\n\n  userTermsStatus(id, token);\n\n\n</script>");
$templateCache.put("app/common/template/top_navigation.html","<div class=\"row border-bottom white-bg\"><nav class=\"navbar navbar-static-top\" role=\"navigation\"><div class=\"navbar-header\"><button aria-controls=\"navbar\" aria-expanded=\"false\" data-target=\"#navbar\" data-toggle=\"collapse\" class=\"navbar-toggle collapsed\" type=\"button\"><i class=\"fa fa-reorder\"></i></button> <a ui-sref=\"procedure.list\" class=\"navbar-brand\"><img src=\"assets/images/logo-header-adm.png\"></a></div><div class=\"navbar-collapse collapse\" id=\"navbar\"><ul class=\"nav navbar-top-links navbar-right\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"img-circle glyphicon glyphicon-user\"></i>&nbsp;{{navigation.user.anaesthetist.name}}</a><ul uib-dropdown-menu=\"\" class=\"animated fadeInRight m-t-xs\"><li><a ui-sref=\"profile.main\">Meus dados</a></li><li><a href=\"\" ng-click=\"navigation.logout()\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></li></ul></div></nav></div>");
$templateCache.put("app/directives/breadcrumbs/breadcrumbs.html","<div><ol class=\"breadcrumb\"><li><ng-switch on=\"breadcrumbs.length === 0\"><span ng-switch-when=\"true\">Home</span> <span ng-switch-default=\"\"><a ng-href=\"#/procedure/main\">Home</a></span></ng-switch></li><li ng-repeat=\"breadcrumb in breadcrumbs\"><span ng-hide=\"(state.active && !state.abstract) || breadcrumb.hide\" class=\"divider\"></span><ng-switch on=\"$last\" ng-hide=\"breadcrumb.hide\"><strong ng-switch-when=\"true\">{{breadcrumb.path}}</strong> <span ng-switch-default=\"\"><a ng-if=\"breadcrumb.oldState\" ui-sref=\"{{breadcrumb.oldState}}\">{{breadcrumb.path}}</a> <strong ng-if=\"!breadcrumb.oldState\" ng-bind=\"breadcrumb.path\"></strong></span></ng-switch></li></ol></div>");
$templateCache.put("app/features/home/home.html","");
$templateCache.put("app/features/login/login-token.html","<div style=\"display: flex; justify-content: center; align-items: center; height: 100%\">&nbsp;<div class=\"lds-spinner\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div>");
$templateCache.put("app/features/login/login.html","<div class=\"row\"><div class=\"col-lg-12 text-center header-login\"><img src=\"assets/images/logo_login-adm.png\"><div style=\"margin-top: -50px;\" class=\"passwordBox animated fadeInDown\"><div class=\"row text-center\"><div class=\"col-md-12\"><div class=\"ibox-content border-shadow\"><form name=\"vm.form\" class=\"m-t\" role=\"form\" ng-submit=\"vm.logar()\" novalidate=\"\"><h2 class=\"font-bold font-green\">{{\'login.LOGIN\' | translate}}</h2><div class=\"form-group\"><input type=\"email\" ng-model=\"vm.credentials.email\" name=\"email\" class=\"form-control\" placeholder=\"{{\'login.EMAIL\' | translate}}\" required=\"\"><div class=\"m-t-xs text-left\" ng-show=\"vm.form.email.$error.required && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.email.$error.required && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small></div><div class=\"m-t-xs text-left\" ng-show=\"vm.form.email.$error.email && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.email.$error.email && vm.form.$submitted\">{{\'form.INVALID_EMAIL\' | translate}}</small></div></div><div class=\"form-group\"><input type=\"password\" ng-model=\"vm.credentials.password\" name=\"password\" class=\"form-control\" placeholder=\"{{\'login.PASSWORD\' | translate}}\" required=\"\"><div class=\"m-t-xs text-left\" ng-show=\"vm.form.password.$invalid && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.password.$invalid && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">{{\'login.ENTRY\' | translate}}</button> <a ui-sref=\"forgot-password\"><small>{{\'login.FORGOT_PASSWORD\' | translate}}</small></a></form></div></div></div><br><div class=\"row text-left\"><div class=\"col-md-7\">Copyright Anestech</div><div class=\"col-md-5 text-right\"><small>© 2018</small></div></div></div></div></div>");
$templateCache.put("app/features/forgot_password/forgot_password.html","<div class=\"row\"><div class=\"col-lg-12 text-center header-login\"><img src=\"assets/images/logo_login-adm.png\"><div style=\"margin-top: -50px;\" class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content border-shadow\"><h2 class=\"font-bold font-green\">{{\'forgot.FORGOT_PASSWORD\' | translate}}</h2><p class=\"text-left\">{{\'forgot.INFO_EMAIL\' | translate}}</p><div class=\"row\"><div class=\"col-lg-12\"><form name=\"vm.form\" class=\"m-t\" role=\"form\" ng-submit=\"vm.enviarEmail()\" novalidate=\"\"><div class=\"form-group\"><input type=\"email\" ng-model=\"vm.forgot.email\" name=\"email\" class=\"form-control\" placeholder=\"{{\'login.EMAIL\' | translate}}\" required=\"\"><div class=\"m-t-xs text-left\" ng-show=\"vm.form.email.$error.required && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.email.$error.required && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small></div><div class=\"m-t-xs text-left\" ng-show=\"vm.form.email.$error.email && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.email.$error.email && vm.form.$submitted\">{{\'form.INVALID_EMAIL\' | translate}}</small></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">{{\'forgot.SEND_NEW_PASS\' | translate}}</button></form></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Einstein Anestech</div><div class=\"col-md-6 text-right\"><small>© 2015-2016</small></div></div></div></div></div>");
$templateCache.put("app/features/procedure/procedure.list.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox-title filter-procedures\"><h2 class=\"pull-left\">Meus procedimentos</h2><form name=\"vm.form\" class=\"m-t\" role=\"form\" ng-submit=\"vm.filtrar()\" novalidate=\"\"><div ibox-tools=\"\"><div style=\"margin-top: -20px; height: 60px;\"><div class=\"btn-group pull-right mg-lt10 mg-rt20\"><label class=\"btn btn-primary ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=\"vm.filtro.tipo\" uib-btn-radio=\"\'list\'\"><i class=\"fa fa-list\"></i></label> <label class=\"btn btn-primary ng-pristine ng-untouched ng-valid ng-not-empty\" ng-model=\"vm.filtro.tipo\" uib-btn-radio=\"\'chart\'\"><i class=\"fa fa-bar-chart-o\"></i></label></div><button class=\"mg-lt10 pull-right btn btn-success\">{{\'form.FILTRAR\' | translate}}</button> <label class=\"pull-right\"><input blur-on-click=\"\" style=\"font-weight: 100; width: 187px;\" date-range-picker=\"\" placeholder=\"Filtro por período...\" class=\"inline form-control date-picker\" name=\"periodo\" options=\"vm.opts\" type=\"text\" ng-model=\"vm.filtro.date\"><div class=\"m-t-xs text-left\" ng-show=\"vm.form.periodo.$error.required && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.periodo.$error.required && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small></div></label></div></div></form></div><div class=\"ibox-content\" ng-if=\"vm.filtro.tipo == \'list\'\"><div class=\"dataTables_wrapper form-inline dt-bootstrap table-responsive\"><table datatable=\"ng\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" class=\"table table-striped table-bordered table-hover row\"><tbody><tr ng-repeat=\"procedure in vm.procedures track by procedure.id\"><td>{{procedure.date}}</td><td>{{procedure.patient}}</td><td>{{procedure.name}}</td><td>{{procedure.medical_plan}}</td><td style=\"width: 100px;\"><span ng-hide=\"true\">{{procedure.procedure_value | number:2}}</span><input class=\"text-right form-control input-fill money\" ng-blur=\"vm.changeValue(\'{{procedure.id}}\',$event)\" ng-value=\"\'{{procedure.procedure_value}}\'\" maxlength=\"10\" type=\"text\"></td><td class=\"text-center\"><button style=\"display: {{procedure.adverse_effect ? \'inline-block\':\'none\';}}\" class=\"btn btn-danger\" type=\"button\"><i class=\"fa fa-warning\"></i></button></td><td class=\"text-center\"><div ng-if=\"procedure.pdf !== null\"><a href=\"{{procedure.pdf_url}}\" target=\"_blank\" class=\"btn btn-primary pull-right\"><i class=\"fa fa-print\"></i></a></div><div ng-if=\"procedure.pdf == null\"><button title=\"PDF não sincronizado pelo App AxReg\" ng-click=\"vm.noPdfAvailable()\" class=\"btn pull-right\" type=\"button\"><i class=\"fa fa-print\"></i></button></div></td></tr></tbody></table></div></div><div class=\"ibox-content\" ng-if=\"vm.filtro.tipo == \'chart\'\"><br><br><div class=\"row\"><div class=\"col-lg-6\"><div class=\"panel panel-primary\"><div class=\"panel-heading\">Horas trabalhadas <small class=\"pull-right\">Últimos 5 dias</small></div><div class=\"panel-body\"><highchart config=\"vm.chartConfig\"></highchart></div></div></div><div class=\"col-lg-6\"><div class=\"panel panel-primary\"><div class=\"panel-heading\">Procedimentos realizados <small class=\"pull-right\">os 10 mais</small></div><div class=\"panel-body\"><highchart config=\"vm.chartConfig2\"></highchart></div></div></div><div class=\"col-lg-6\"><div class=\"panel panel-primary\"><div class=\"panel-heading\">Convênios <small class=\"pull-right\">Últimos 5 dias</small></div><div class=\"panel-body\"><highchart config=\"vm.chartConfig3\"></highchart></div></div></div><div class=\"col-lg-6\"><h2>Estimativa de renda</h2><div class=\"col-lg-4\" style=\"padding: 0;\"><div class=\"box-procedure\"><h1>{{vm.reports.total}}</h1><p class=\"text-left\">Total de procedimentos</p></div></div><div class=\"col-lg-4\" style=\"padding: 0;\"><div class=\"box-procedure\"><h3>R$</h3><h2>{{vm.reports.average_value | number:2}}</h2><p class=\"text-left\">Média de valor a receber</p></div></div><div class=\"col-lg-4\" style=\"padding: 0;\"><div class=\"box-procedure\"><h3>R$</h3><h2>{{vm.reports.value | number:2}}</h2><p class=\"text-left\">Total a receber</p></div></div></div></div></div></div></div></div>");
$templateCache.put("app/features/profile/profile.html","<div class=\"wrapper animated fadeInRight\"><div class=\"row m-b-lg m-t-lg\"><div class=\"ibox\"><div class=\"ibox-content\"><form name=\"vm.form\" class=\"m-t\" role=\"form\" ng-submit=\"vm.atualizar()\" novalidate=\"\"><div class=\"row\"><div class=\"col-lg-3\"></div><div class=\"col-lg-6\"><h2>MEUS DADOS</h2><div class=\"form-group\"><label><span translate=\"\">profile.NAME</span></label><div class=\"m-t-xs\">{{vm.profile.name}}</div></div><div class=\"form-group\"><label><span translate=\"\">profile.CPF</span></label><div class=\"m-t-xs cpf\">{{vm.profile.cpf}}</div></div><div class=\"row\"><div class=\"col-lg-6 form-group\"><label><span translate=\"\">profile.CRM</span></label><div class=\"m-t-xs\">{{vm.profile.crm_number}}</div></div><div class=\"col-lg-6 form-group\"><label><span translate=\"\">profile.STATE</span></label><div class=\"m-t-xs\">{{vm.crmState.name}}</div></div></div><div class=\"form-group\"><label><span translate=\"\">profile.EMAIL</span></label><div class=\"m-t-xs\">{{vm.profile.contact_email}}</div></div><div class=\"row\"><div class=\"col-lg-12\"><h3 translate=\"\">profile.INFO_ADD</h3></div></div><div class=\"row\"><div class=\"col-lg-6 form-group\"><label><span translate=\"\">profile.COUNTRY</span></label><div class=\"m-t-xs\">{{vm.country.name}}</div></div><div class=\"col-lg-6 form-group\"><label><span translate=\"\">profile.STATE</span></label><div class=\"m-t-xs\">{{vm.state.name}}</div></div></div><div class=\"form-group\"><label><span translate=\"\">profile.RQE</span></label><div class=\"m-t-xs\">{{vm.profile.rqe}}</div></div><div class=\"form-group\"><label><span translate=\"\">profile.PHONE</span></label><div class=\"m-t-xs phone\">{{vm.profile.phone_number}}</div></div></div><div class=\"col-lg-3\"></div></div></form></div></div></div></div>");
$templateCache.put("app/features/forgot_password/reset/forgot_password_reset.html","<div class=\"row\"><div class=\"col-lg-12 text-center header-login\"><img src=\"assets/images/logo_login-adm.png\"><div style=\"margin-top: -50px;\" class=\"passwordBox animated fadeInDown\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"ibox-content border-shadow\"><h2 class=\"font-bold font-green\">{{\'forgot.RESET_PASSWORD\' | translate}}</h2><p class=\"text-left\">{{\'forgot.INFO_PASS\' | translate}}</p><div class=\"row\"><div class=\"col-lg-12\"><form name=\"vm.form\" class=\"m-t\" role=\"form\" ng-submit=\"vm.changePassword()\" novalidate=\"\"><div class=\"form-group\"><input type=\"password\" ng-pattern=\"/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{8,}$/\" ng-model=\"vm.forgot.password_new\" name=\"password_new\" class=\"form-control\" placeholder=\"{{\'login.PASSWORD\' | translate}}\" required=\"\"><div class=\"m-t-xs text-left\" ng-show=\"(vm.form.password_new.$error.required || vm.form.password_new.$error.pattern) && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.password_new.$error.required && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small> <small class=\"text-danger\" ng-show=\"vm.form.password_new.$error.pattern && vm.form.$submitted\">{{\'form.PATTERN\' | translate}}</small></div></div><div class=\"form-group\"><input type=\"password\" ng-model=\"vm.confirm_password\" name=\"confirm_password\" class=\"form-control\" placeholder=\"{{\'login.CONFIRM_PASSWORD\' | translate}}\" required=\"\"><div class=\"m-t-xs text-left\" ng-show=\"vm.form.confirm_password.$error.required && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.confirm_password.$error.required && vm.form.$submitted\">{{\'form.REQUIRED\' | translate}}</small></div><div class=\"m-t-xs text-left\" ng-show=\"vm.confirm_password && vm.confirm_password != vm.forgot.password_new && vm.form.$submitted\"><small class=\"text-danger\" ng-show=\"vm.form.password_new.$valid && (vm.confirm_password != vm.forgot.password_new) && vm.form.$submitted\">{{\'forgot.PASSWORD_DISTINCT\' | translate}}</small></div></div><button type=\"submit\" class=\"btn btn-primary block full-width m-b\">{{\'forgot.CHANGE_PASS\' | translate}}</button></form></div></div></div></div></div><hr><div class=\"row\"><div class=\"col-md-6\">Copyright Einstein Anestech</div><div class=\"col-md-6 text-right\"><small>© 2015-2016</small></div></div></div></div></div>");}]);